<script>
  export let title;
  export let options;
  export let selectedOption;
  export let code;
  export let onChange;
  export let error = true;
  export let loading = false;
  export let loaded = false;
</script>

{#if loading}
  <div class="loading">
    <img src="/images/loading.gif" alt="Loading Anim" />
  </div>
{:else if loaded}
  <div class="autoformsection fullwidth marginbottom">
    <div class="formtitle marginbottom staticwidth">{title}</div>
    <div class="formfieldcontainer nomargin">
      <div
        class="comboboxstyle surveyCombo fullwidth marginbottom {error
          ? 'error'
          : ''}"
      >
        <div class="arrow">
          <img
            src="/images/down-arrow.svg"
            loading="lazy"
            alt=""
            class="comboboxicon"
          />
        </div>
        <select bind:value={selectedOption} on:change={onChange}>
          {#each options as option}
            <option value={option.value}>{option.label}</option>
          {/each}
        </select>
      </div>
      <div class="formsubtitle greytextstyle">
        {code !== "-1" ? code : ""}
      </div>
    </div>
  </div>
{/if}

<style>
  select {
    width: 100%;
    height: 100%;
    margin: 0px;
    background-color: transparent;
    border: 0px;
    padding-left: 18px;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: "";
    cursor: pointer;
    outline: none;
  }

  option {
    padding: 100px 0px 10px 0px;
  }

  div.surveyCombo {
    padding: 0px;
    height: 45px;
  }

  div.comboboxstyle {
    position: relative;
  }

  div.arrow {
    position: absolute;
    height: 100%;
    right: 18px;
    top: 0px;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  div.error {
    border: 1px solid red;
  }

  div.loading {
    margin-bottom: 50px;
  }

  div.loading img {
    width: 40px;
  }
</style>
